import React, {Component } from "react";
 
import ReactDOM from "react-dom";
 
class EditImagewithRadio extends Component {
    

    selectedanswer=(answer,id) =>{
         
       //////console.log(answer)
      // ////console.log(id)

        this.props.selected(answer,id);
               
    }


    render() {
        return (
            <div className="questionBox">
              <img src = {this.props.question} />
              {this.props.answer.map((text, index) => (
                 <tr  key={this.props.id+index} > <td>
                <label key={index}> 
                
                <input type="radio"
                  key={this.props.id+index}
                  value={text}
                  name={this.props.id}
                  
                  onClick={() => {
                    this.selectedanswer(text,this.props.id);  
                     
                  }}
                />
                  {text}
                  </label>
                  </td>
                  </tr>
              ))}
                
            </div>
          );
      }


}

export default EditImagewithRadio;